import React, { useEffect, useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import EditBtn from '../../../buttons/EditBtn'
import DeleteBtn from '../../../buttons/DeleteBtn'
import PlusBtn from '../../../buttons/PlusBtn'
import { NoInfo } from '../../../common/NoInfo'
import { departamentsActions } from '../../../../actions/departamentsActions'
import { specialtiesActions } from '../../../../actions/specialtiesActions'
import { positionsActions } from '../../../../actions/positionsActions'
import { timeSlotsActions } from '../../../../actions/timeSlotsActions'
import '../../../../assests/styles/contatcs/ContactDetail.scss'

const ContactHospitalsListComponent = ({
  hospitalsContact,
  handleRemoveHospitalContact,
  toEditContactHospitalForm,
  editDeleteView,
  toAddAnOtherHospitalToContact,
}) => {
  const dispatch = useDispatch()

  const [classTableGrid, setClassTableGrid] = useState('')

  const getAllDepartaments = () =>
    dispatch(departamentsActions.getAllDepartaments())
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties(0))
  const getAllPositions = () => dispatch(positionsActions.getAllPositions())
  const getAllTimeSlots = () => dispatch(timeSlotsActions.getAllTimeSlots())

  const departaments = useSelector((state) => state.departaments)
  const specialties = useSelector((state) => state.specialties)
  const positions = useSelector((state) => state.positions)
  const timeslots = useSelector((state) => state.timeSlots)

  useEffect(() => {
    changeClassName()
  }, [classTableGrid])

    useEffect(() => {
      getAllDepartaments()
      getAllSpecialties()
      getAllPositions()
    }, [])

  const changeClassName = () => {
    if (editDeleteView) {
      setClassTableGrid('products__sub__titles-col7-2 mb-10')
    } else {
      setClassTableGrid('products__sub__titles-col5-2 mb-10')
    }
  }

  return (
    <>
      <div className='products__title__container'>
        <h2>Hospitales / Centros del contacto</h2>
        {/* añadimos un hopital nuevo a este contacto */}
        {editDeleteView ? (
          <span
            className='products__add'
            onClick={() => toAddAnOtherHospitalToContact()}
          >
            <PlusBtn />
            <h3>Añadir un Hospital / Centro</h3>
          </span>
        ) : null}
      </div>
      <table className='contact-hospitals-table'>
        <thead>
          <tr>
            <th>
              Hospital / Centro
            </th>
            <th>
              Departamento
            </th>
            <th>
              Especialidad
            </th>
            <th>
              Cargo
            </th>
            <th>
              Horario
            </th>
            {editDeleteView && (
              <th className="table-th-actions" style={{ width: '220px', minWidth: '220px', textAlign: 'right'}}>
                Acciones
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {hospitalsContact
            ? hospitalsContact.map((hospital) => {
                // Buscar el nombre del departamento por id_TipoDepartamento
                const departamento = departaments.find(
                  (dep) => dep.id_TipoDepartamento === hospital.id_TipoDepartamento
                )
                const especialidad = specialties.find(
                  (spe) => spe.id_TipoEspecialidad === hospital.id_TipoEspecialidad
                )
                const cargo = positions.find(
                  (car) => car.id_TipoCargo === hospital.id_TipoCargo
                )
                const franja = timeslots.find(
                  (tim) => tim.id_TipoFranjaHoraria === hospital.id_TipoFranjaHoraria
                )
                return (
                  <tr key={hospital.id_ContactoHospital}>
                    <td>
                      {hospital.nombre}
                    </td>
                    <td>
                      {/* {hospital.id_TipoDepartamento} */}
                      {departamento ? departamento.nombre : NoInfo('Sin Departamento')}
                    </td>
                    <td>
                      {/* {hospital.id_TipoEspecialidad} */}
                      {especialidad ? especialidad.nombre : NoInfo('Sin Especialidad')}
                    </td>
                    <td>
                      {/* {hospital.id_TipoCargoNombre} */}
                      {cargo ? cargo.nombre : NoInfo('Sin Cargo')}
                    </td>
                    <td>
                      {franja ? franja.nombre : NoInfo('Sin Franja Horaria')}
                    </td>
                    {editDeleteView && (
                        <td className="table-td-actions">
                          <button
                            onClick={() =>
                              toEditContactHospitalForm(
                                hospital.id_ContactoHospital,
                              )
                            }
                          >
                            <EditBtn />
                          </button>
                          <button
                            onClick={() =>
                              handleRemoveHospitalContact(
                                hospital.id_ContactoHospital,
                              )
                            }
                          >
                            <DeleteBtn />
                          </button>
                        </td>
                    )}
                  </tr>
                );
              })
            : null}
        </tbody>
      </table>
    </>
  )
}
export default ContactHospitalsListComponent
